import axios from "axios";
import { CONFIG } from "@/constants/config.js";

const distributorInvoicesBackend = CONFIG.BACKEND_URL + "distributor/invoices";

const state = {
  distributorInvoice: {},
  distributorInvoices: [],
  loading: false,
  error: "",
  currentPage: 1,
  numPages: 1,
  totalRows: 0,
};

const config = () => ({
  headers: {
    Token: localStorage.getItem("accessToken"),
  },
});

const getters = {
  distributorInvoice: (state) => state.distributorInvoice,
  allDistributorInvoices: (state) => state.distributorInvoices,
  distributorInvoicesLoading: (state) => state.loading,
  distributorInvoicesError: (state) => state.error,
  distributorInvoicesCurrentPage: (state) => state.currentPage,
  distributorInvoicesNumPages: (state) => state.numPages,
  distributorInvoicesTotalRows: (state) => state.totalRows,
};

const actions = {
  async getDistributorInvoice({ commit /*, dispatch */ }, id) {
    commit("setLoading", true);
    await axios
      .post(`${distributorInvoicesBackend}/${id}/`, null, config())
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributorInvoice", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
        commit("setLoading", false);
      });
  },
  async getDistributorInvoices({ commit /*, dispatch */ }, filter = null) {
    commit("setLoading", true);
    await axios
      .post(`${distributorInvoicesBackend}/all/`, filter, config())
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributorInvoices", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  async addDistributorInvoice({ commit /*, dispatch */ }, expense) {
    commit("setLoading", true);
    await axios
      .post(`${distributorInvoicesBackend}/insert/`, expense, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  async editDistributorInvoice({ commit, dispatch }, expense) {
    commit("setLoading", true);
    await axios
      .patch(`${distributorInvoicesBackend}/update/`, expense, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  async deleteDistributorInvoice({ commit, dispatch }, id) {
    commit("setLoading", true);
    await axios
      .delete(`${distributorInvoicesBackend}/delete/${id}/`, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  async resetDistributorInvoices({ commit }) {
    await commit("reset");
  },
};

const mutations = {
  reset(state) {
    state.distributorInvoice = {};
    state.distributorInvoices = [];
    state.loading = false;
    state.error = "";
    state.currentPage = 1;
    state.numPages = 1;
    state.totalRows = 0;
  },
  setDistributorInvoice(state, response) {
    state.distributorInvoice = response;
  },
  setDistributorInvoices(state, response) {
    state.distributorInvoices = response.distributorInvoices;
    state.currentPage = response.currentPage;
    state.numPages = response.numPages;
    state.totalRows = response.totalRows;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
